// auth-api 에러 코드 → 한글 메시지 매핑.
// 코드 없는 케이스는 fallback 으로 코드 그대로 노출.

const MAP: Record<string, string> = {
  // auth
  invalid_credentials: '아이디 또는 비밀번호가 올바르지 않습니다',
  account_inactive: '비활성 계정입니다. 관리자에게 문의하세요',
  account_locked_until: '잠긴 계정입니다. 잠시 후 다시 시도하세요',
  emergency_lock: '긴급 잠금된 계정입니다. 관리자에게 문의하세요',
  org_locked: '소속 조직이 잠겨있습니다',
  rate_limited: '요청이 너무 많습니다. 잠시 후 다시 시도하세요',
  invalid_refresh: '세션이 만료됐습니다. 다시 로그인하세요',
  refresh_not_found: '세션이 만료됐습니다',
  refresh_expired: '세션이 만료됐습니다',
  refresh_reuse_detected: '보안상 모든 세션이 종료됐습니다. 다시 로그인하세요',
  account_state_changed: '계정 상태가 변경됐습니다. 다시 로그인하세요',
  invalid_reset_token: '재설정 링크가 유효하지 않습니다',
  reset_token_expired: '재설정 링크가 만료됐습니다',
  reset_token_used: '이미 사용한 재설정 링크입니다',
  password_policy_failed: '비밀번호 정책을 만족하지 않습니다',
  session_expired: '세션이 만료됐습니다. 다시 로그인하세요',

  // signup
  email_already_exists: '이미 사용 중인 이메일입니다',
  person_id_already_exists: '이미 등록된 식별자입니다',

  // org
  duplicate_request: '이미 요청한 조직입니다',
  organization_not_found: '조직을 찾을 수 없습니다',
  permission_denied: '권한이 없습니다',
  not_pending: '이미 처리된 요청입니다',
  owner_only: '본인 요청만 가능합니다',

  // generic
  invalid_user_id: '잘못된 사용자 ID',
  missing_authorization: '인증이 필요합니다',
};

export function errorMessage(code: string, fallback?: string): string {
  return MAP[code] ?? fallback ?? `오류: ${code}`;
}
